import { render, staticRenderFns } from "./sigleTaskTable.vue?vue&type=template&id=5940e3ba&scoped=true"
import script from "./sigleTaskTable.vue?vue&type=script&lang=js"
export * from "./sigleTaskTable.vue?vue&type=script&lang=js"
import style0 from "./sigleTaskTable.vue?vue&type=style&index=0&id=5940e3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5940e3ba",
  null
  
)

export default component.exports